import React from 'react';
import { Typography, Box, IconButton } from '@mui/material';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { styled } from '@mui/material';
// import Header from 'src/components/Header/Header';
import { Navigate } from 'react-router-dom';
/* @useSignals */
import { usuarioSignal } from '../../signals/usuario';

const StyledBox = styled(Box)({
    padding: 24,
    width: '97%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
});

const Text = styled(Typography)({
    color: 'rgb(79, 79, 79)'
});

const NaoAutorizado = () => {
    // if (usuarioSignal.value.isAuthorized) return <Navigate replace to="/apps" />;
    return (
        <>
            <StyledBox>
                <Typography variant="h1" component="div" sx={{ display: 'flex', alignItems: 'center', fontSize: '1.7rem', fontWeight: '600', lineHeight: '130%'}}>
                    <ErrorOutlineOutlinedIcon/>
                    Não autorizado
                </Typography>
                <Text>Por favor, tente reconectar no sistema. Para isso você deverá clicar no ícone que está no canto superior direito da tela e depois no botão "Sair".</Text>
                <Text>
                    Em seguida, limpe a cache de dados do seu navegador.
                    Para saber como limpar a cache no Firefox, <a target="_blank" href="https://support.mozilla.org/pt-BR/kb/como-limpar-cache-firefox" rel="noopener noreferrer">clique aqui</a>.
                    Para saber como limpar a cache no Google Chrome, <a target="_blank" href="https://support.google.com/accounts/answer/32050?hl=pt-BR&co=GENIE.Platform%3DDesktop" rel="noopener noreferrer">clique aqui</a>.
                </Text>
                <Text>Por fim, entre novamente no sistema com o mesmo usuário e senha que você utiliza normalmente.</Text>
                <Text>Se o erro persistir, entre em contato com o seu suporte.</Text>
            </StyledBox>
        </>
    );
};

export default NaoAutorizado;
